import TabelaNBSService from "@/services/TabelaNBSService";

export const tabelaNBS = {
  namespaced: true,
  state: {
    tabelaNBS: {},
  },
  actions: {
    getTabelaNBS({ commit }, payload) {
      return TabelaNBSService.GetTabelaNBS(payload).then(
        (tabelaNBS) => {
          return Promise.resolve(tabelaNBS);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTabelaNBS({ commit }, payload) {
      return TabelaNBSService.PostTabelaNBS(payload).then(
        (tabelaNBS) => {
          return Promise.resolve(tabelaNBS);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTabelaNBS({ commit }, payload) {
      return TabelaNBSService.PutTabelaNBS(payload).then(
        (tabelaNBS) => {
          return Promise.resolve(tabelaNBS);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTabelaNBS({ commit }, payload) {
      return TabelaNBSService.DeleteTabelaNBS(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTabelaNBSOData({ commit }, payload) {
      return TabelaNBSService.GetTabelaNBSOData(payload).then(
        (tabelaNBS) => {
          return Promise.resolve(tabelaNBS);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    atualizarTabelaNBS({ commit }, payload) {
      return TabelaNBSService.AtualizarTabelaNBS(payload).then(
        (tabelaNBS) => {
          return Promise.resolve(tabelaNBS);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default tabelaNBS;
